import React from 'react';
import ReactJoyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';

class Tutorial extends React.Component {

    stopOngoingTutorial = () => {
        this.props.stopTutorial();
    }

    getNextStepNumber = (data) => {
        if (data.action === ACTIONS.PREV) {
            return this.props.tutorial.stepIndex - 1
        } else if (data.action === ACTIONS.NEXT) {
            return this.props.tutorial.stepIndex + 1
        } else if (data.action === ACTIONS.CLOSE) {
            this.stopOngoingTutorial()
        }
    }

    callback = (data) => {
        // console.log('data', data, this.props);
        let nextStepId;
        switch (data.type) {
            case EVENTS.TARGET_NOT_FOUND:
                // this.props.stopTutorial();
                // this.props.updateStepNumber(data.index + (data.action === ACTIONS.PREV ? -1 : 1));
                break;
            case EVENTS.STEP_AFTER:
                if (this.props.tutorial.type === 'first-page') {
                    nextStepId = this.getNextStepNumber(data);
                    this.props.updateStepNumber(nextStepId);
                }
                break;
            // case EVENTS.TOUR_END:
            //     this.stopOngoingTutorial()
            //     break;
            default:

            // do nothing
        }
    }

    render() {
        return (
            <ReactJoyride
                ref={(c) => (this.joyride = c)}
                continuous
                run={this.props.tutorial.isRunning}
                steps={this.props.tutorial.steps}
                stepIndex={this.props.tutorial.stepIndex}
                callback={this.callback}
                styles={
                    {
                        options: {
                            arrowColor: 'black',
                            backgroundColor: 'white',
                            overlayColor: 'rgba(0, 0, 0, 0.6)',
                            primaryColor: 'black',
                            textColor: 'black',
                            arrowColor: 'white',
                        },
                        buttonClose: {
                            display: 'none',
                        }
                    }
                }
                // disableOverlay={false}
                disableBeacon
                disableCloseOnEsc
                disableOverlayClose
                scrollToFirstStep
                showBackButton
                disableOverlayClicks
            />
        );
    }
}

Tutorial.propTypes = {};
Tutorial.defaultProps = {};

export default Tutorial;


// WEBPACK FOOTER //
// /src/components/tutorial/Tutorial.js